import axios from "axios";

/**
 * Delete a road recording by its ID.
 * @param {string} baseUrl - The base URL for the API.
 * @param {string} id - The unique ID of the road recording to delete.
 * @returns {Promise<boolean|string>} - Returns true on success, or 'error' string on failure.
 */
export async function deleteRoadRecording(baseUrl, id) {
    try {
        const response = await axios.delete(`${baseUrl}/admin/deleteRoadRecording/${id}`, {
            timeout: 7000, // 7sec timeout
        });

        if (response.status === 200) {
            return response.data;
        } else {
            console.error("Unexpected response status:", response.status, response.data);
            return 'An error occured while deleting the recording.'
        }
    } catch (error) {
        if (error.code === 'ECONNABORTED') {
            console.error('Request timed out!');
        } else if (error.response) {
            console.error("Backend returned error status:", error.response.status, error.response.data);
        } else if (error.request) {
            console.error("No response received from backend:", error.request);
        } else {
            console.error("Error setting up the request:", error.message);
        }
        return 'An error occured while deleting the recording.'
    }
}
